import React from 'react'

import { maskString } from 'utils/functions'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import {
  CONFLICT_TYPES_LIST,
  CONFLICTING_CNAE_TYPES_MESSAGES,
} from 'utils/constants/conflictingCnaeTypes'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import _ from 'lodash'
import DataUnavailableText from '../../DataUnavailableText'
import ListItem from '../../../ListItem'
import { DataField } from '../../../Label'
import ContentBox from '../../../ContentBox'
import ErrorDataText from '../../ErrorDataText'

const styles = StyleSheet.create({
  label: {
    marginBottom: 16,
  },
  content: {
    marginTop: 16,
  },
  details: {
    paddingLeft: 8,
    paddingRight: 8,
  },
})

const CompanyDataVariableReport = (props) => {
  const { companyData } = props
  const compareCompanies = (companyA, companyB) => {
    const equalCadastralSituation = companyA.cadastral_situation === companyB.cadastral_situation
    const equalCNPJ = companyA.cnpj[0].slice(0, 7) === companyB.cnpj[0].slice(0, 7)
    return equalCNPJ && equalCadastralSituation
  }

  const unifyCompaniesByCnpjAndStatus = (companiesList) => {
    const filteredCompanies = []

    companiesList.forEach((companyValues) => {
      const company = {
        cnpj: [companyValues.cnpj],
        name: companyValues.name,
        cadastral_situation: companyValues.cadastral_situation,
        conflict_classification: companyValues.conflict_classification,
        details: { data: { cnaes: companyValues.details.data.cnaes } },
        conflicts: companyValues.conflicts,
      }

      const index = filteredCompanies.findIndex((filteredCompany) => {
        return compareCompanies(filteredCompany, company)
      })

      if (index !== -1) {
        filteredCompanies[index].cnpj.push(company.cnpj[0])
      } else {
        filteredCompanies.push(company)
      }
    })

    return filteredCompanies
  }

  const sortByCadastralSituation = (companyA, companyB) => {
    if (companyA.cadastral_situation === 'ATIVA' && companyB.cadastral_situation === 'ATIVA')
      return 0
    if (companyA.cadastral_situation === 'ATIVA' && companyB.cadastral_situation === 'BAIXADA')
      return -1
    if (companyA.cadastral_situation === 'BAIXADA' && companyB.cadastral_situation === 'ATIVA')
      return 1
    return 0
  }
  try {
    const companies = unifyCompaniesByCnpjAndStatus(companyData.companies).sort((a, b) =>
      sortByCadastralSituation(a, b),
    )
    return companyData?.has_active_companies ? (
      <View>
        <Text style={styles.label}>Empresas com participação societária:</Text>
        {companies.map((company) => {
          const { conflicts, conflict_classification } = company
          const conflictMessage = CONFLICTING_CNAE_TYPES_MESSAGES[conflict_classification]
          const cnaes = company.details.data.cnaes.map((cnae) => {
            if (_.isEmpty(cnae)) {
              return {}
            }
            const code = maskString(cnae.number?.toString(), 'cnae')
            return {
              code: code,
              ...cnae,
              conflicting_companies: CONFLICT_TYPES_LIST.includes(conflict_classification)
                ? conflicts?.filter((conflict) => conflict.cnae === code)[0]?.conflicting_companies
                : null,
            }
          })
          return (
            <View key={company.cnpj[0]}>
              <ContentBox>
                <DataField label={company.name || 'N/A'} />
                <DataField label="Situação cadastral:" value={company.cadastral_situation} />
                <DataField
                  label="CNPJ(s):"
                  value={company.cnpj.map(
                    (cnpj, i) =>
                      `${maskString(cnpj, 'cnpj')}${i < company.cnpj.length - 1 ? ', ' : ''}`,
                  )}
                />

                {conflictMessage && <DataField label={conflictMessage} />}

                {cnaes.length > 0 && (
                  <View>
                    <DataField label="Atividades exercidas:" />
                    {cnaes.map((cnae) => (
                      <View style={styles.details} key={cnae.code}>
                        <DataField label="CNAE: " value={cnae.code} />
                        <DataField label="Descrição da atividade:" value={cnae.description} />
                        {cnae.conflicting_companies && (
                          <View>
                            <Text style={styles.label}>
                              Empresas do grupo XP conflitantes com essa atividade:
                            </Text>

                            {addKeyToObjectsArray(
                              cnae.conflicting_companies?.map((c_company) => {
                                return { name: c_company }
                              }),
                            )?.map((conflicting_company) => (
                              <ListItem key={conflicting_company.key}>
                                <DataField label={conflicting_company.name} />
                              </ListItem>
                            ))}
                          </View>
                        )}
                      </View>
                    ))}
                  </View>
                )}
              </ContentBox>
            </View>
          )
        })}
      </View>
    ) : (
      <DataUnavailableText />
    )
  } catch (e) {
    return <ErrorDataText exception={e} contextName="CompanyDataReport" extraData={companyData} />
  }
}
export default CompanyDataVariableReport
